// Generated file - do not change manually!

/**
 * Different types of Button.
 */
export enum LinkDesign {
  /**
   * default type (no special styling)
   */
  Default = 'Default',

  /**
   * emphasized type
   */
  Emphasized = 'Emphasized',

  /**
   * subtle type (appears as regular text, rather than a link)
   */
  Subtle = 'Subtle'
}
